import { useEffect, useMemo } from 'react';
import { EventBus } from '@vtblife/event-bus';
import { LandingEventsManager } from './landing-events-manager';
const eventBus = EventBus.getInstance();
export const useLandingEventsManager = (requestEventType, responseEventType) => {
    const landingEventsManagerInstance = useMemo(() => new LandingEventsManager(requestEventType, responseEventType, eventBus), [requestEventType, responseEventType]);
    useEffect(() => () => landingEventsManagerInstance.dispose(), [landingEventsManagerInstance]);
    return landingEventsManagerInstance;
};
//# sourceMappingURL=use-landing-events-manager.js.map